module.exports = __webpack_public_path__ + "static/media/redeemed-arrow.f83dd78c.svg";